"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _pacomo = require("utils/pacomo");

var _selectors = require("selectors");

var _reactIntl = require("react-intl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompleteBar = function CompleteBar(_ref) {
    var user = _ref.user,
        passengersById = _ref.passengersById;

    var pax = passengersById[user.customerId];
    if (pax && user && user.isG2G && !user.prompt) {
        return _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement("img", { className: "plane1", src: require('theme/img/plane.png') }),
            _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                    "span",
                    null,
                    _react2.default.createElement(
                        "strong",
                        null,
                        pax && pax.name.legal_first_name
                    ),
                    ",",
                    " ",
                    _react2.default.createElement(
                        "em",
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: "CompleteBar.paxGoodToGo",
                            defaultMessage: "You're Good to Go"
                        })
                    )
                )
            ),
            _react2.default.createElement("img", { className: "plane2", src: require('theme/img/plane.png') })
        );
    } else {
        return _react2.default.createElement("div", null);
    }
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        user: state.user,
        passengersById: (0, _selectors.getCustomersById)(state)
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _pacomo.pacomoTransformer)(CompleteBar));
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/components/CompleteBar.js
// module id = 1295
// module chunks = 0